import { render, staticRenderFns } from "./LeftMenuItem.vue?vue&type=template&id=78945dea"
import script from "./LeftMenuItem.ts?vue&type=script&lang=js&external"
export * from "./LeftMenuItem.ts?vue&type=script&lang=js&external"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports